<template>
    <div class="cookie">
        <div v-if="CookieSeen" id="cookies-eu-banner" data-wait-remove="1200">
            We use technical and analytics cookies to ensure that we give you the best experience on our website.
            <router-link to="/privacy-policy"><a id="cookies-eu-more">More information</a></router-link>
            <button class="cookies-eu-accept" v-on:click="acceptCookie()" >Accept</button>
        </div>
    </div>
</template>
<script>
   export default {
    data() {
      return {
         CookieSeen: []
      };
    },
    beforeMount(){
      this.getCookieSeen()
    },
    created () {
      this.cookieTimeout = 31104000000; // 12 months in milliseconds
      this.bots = /bot|crawler|spider|crawling/i;
      this.cookieName = "hasConsent";
      this.trackingCookiesNames = [
         "__utma",
         "__utmb",
         "__utmc",
         "__utmt",
         "__utmv",
         "__utmz",
         "_ga",
         "_gat",
         "_gid"
        ];
        this.init();
    },
    methods: {
      getCookieSeen: function(){
        var status = localStorage.getItem("CookieSeen");
        if (!status) {
          this.CookieSeen = true;
        } else {       
          this.CookieSeen = false;
        }

      },
      acceptCookie: function (){
        localStorage.setItem("CookieSeen", true);
        this.removeBanner();
        this.setConsent(true);
      },
      init: function () {
      // Detect if the visitor is a bot or not
      // Prevent for search engine take the cookie alert message as main content of the page
      var isBot = this.bots.test(navigator.userAgent);

      // Check if DoNotTrack is activated
      var dnt =
        navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack;
      var isToTrack =
        dnt !== null && dnt !== undefined
          ? dnt && dnt !== "yes" && dnt !== 1 && dnt !== "1"
          : true;

      // Do nothing if it is a bot
      // If DoNotTrack is activated, do nothing too
      if (isBot || !isToTrack || this.hasConsent() === false) {
        this.removeBanner(0);
        return false;
      }

      // User has already consent to use cookies to tracking
      if (this.hasConsent() === true) {

        return true;
      }

      // If it's not a bot, no DoNotTrack and not already accept, so show banner
      this.showBanner();

      if (!this.waitAccept) {
        // Accept cookies by default for the next page
        this.setConsent(true);
      }
    },
    showBanner: function () {


    },
    setConsent: function (consent) {
      if (this.useLocalStorage) {
        return localStorage.setItem(this.cookieName, consent);
      }

      this.setCookie(this.cookieName, consent);
    },
    hasConsent: function () {
      var cookieName = this.cookieName;
      var isCookieSetTo = function (value) {
        return (
          document.cookie.indexOf(cookieName + "=" + value) > -1 ||
          localStorage.getItem(cookieName) === value
        );
      };

      if (isCookieSetTo("true")) {
        return true;
      } else if (isCookieSetTo("false")) {
        return false;
      }

      return null;
    },
    setCookie: function (name, value) {
      var date = new Date();
      date.setTime(date.getTime() + this.cookieTimeout);

      document.cookie =
        name + "=" + value + ";expires=" + date.toGMTString() + ";path=/";
    },
    deleteCookie: function (name) {
      var hostname = document.location.hostname.replace(/^www\./, ""),
        commonSuffix = "; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/";

      document.cookie = name + "=; domain=." + hostname + commonSuffix;
      document.cookie = name + "=" + commonSuffix;
    },
    addClickListener: function (DOMElement, callback) {
      if (DOMElement.attachEvent) {
        // For IE 8 and earlier versions
        return DOMElement.attachEvent("onclick", callback);
      }

      // For all major browsers, except IE 8 and earlier
      DOMElement.addEventListener("click", callback);
    },
    removeBanner: function (wait) {
      var banner = document.getElementById("cookies-eu-banner");
      banner.classList.add("before-remove");
      setTimeout(function () {
        if (banner && banner.parentNode) {
          banner.parentNode.removeChild(banner);
        }
      }, wait);
    }
    }
  }


/*
(function (root, factory, undefined) {
  "use strict";
  if (typeof define === "function" && define.amd) {
    define([], factory);
  } else if (typeof exports === "object") {
    module.exports = factory();
  } else {
    // root is window
    root.CookiesEuBanner = factory();
  }
})(window, function () {
  "use strict";

  var CookiesEuBanner,
    document = window.document;

  CookiesEuBanner = function (
    launchFunction,
    waitAccept,
    useLocalStorage,
    undefined
  ) {
    if (!(this instanceof CookiesEuBanner)) {
      return new CookiesEuBanner(launchFunction);
    }

    this.cookieTimeout = 31104000000; // 12 months in milliseconds
    this.bots = /bot|crawler|spider|crawling/i;
    this.cookieName = "hasConsent";
    this.trackingCookiesNames = [
      "__utma",
      "__utmb",
      "__utmc",
      "__utmt",
      "__utmv",
      "__utmz",
      "_ga",
      "_gat",
      "_gid"
    ];
    this.launchFunction = launchFunction;
    this.waitAccept = waitAccept || false;
    this.useLocalStorage = useLocalStorage || false;
    this.init();
  };

  CookiesEuBanner.prototype = {
    
  };

  return CookiesEuBanner;
});

var cookiesBanner = new CookiesEuBanner(function () {
  // Your code here
  console.log("callback", this);
  console.log("This is were the Google-Analytics code snippet should go");
  // document.getElementById("cookies-eu-banner").classList.add("hide-it");
}, true);
*/
</script>
<style>
.show-it{
	display: block;
}
#cookies-eu-banner {
    position: fixed;
    bottom: 100px;
    right: 20px;
    border-radius: 10px;
    background: #4A414D;
    color: #fff;
    padding: 10px 15px;
    width: 280px;
    z-index: 100;
}

#cookies-eu-more {
  padding: 0 0.25em;
  white-space: nowrap;
  color: #16a085;
}

.cookies-eu-accept {
  padding: 0.25em 0.5em 0.2em;
  transition: 300ms all;
  background: #16a085;
  border: 2px solid #16a085;
  color: #FFFFFF;
  border-radius: 5px;
}
.cookies-eu-accept:hover {
  padding: 0.25em 0.5em 0.2em;
  transition: 300ms all;
  background: none;
  color: #16a085;
}

@keyframes showCookieBanner {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0%);
  }
}
@keyframes hideCookieBanner {
  from {
    transform: translateY(0%);
  }
  to {
    transform: translateY(100%);
  }
}
</style>